import React from 'react';

const stateToCss = (state) => {
  switch (state) {
    case 'changed':
      return 'warning';
    case 'added':
      return 'positive';
    case 'removed':
      return 'negative';
    default:
      return '';
  }
};

export default function OrderedListChangesCard({ title, description, data }) {
  const shouldShowImpact = data.some((v) => v.impact);

  const row = (obj, index) => {
    return (
      <div
        key={index}
        className='row values'
      >
        <div className={`column ${stateToCss(obj.current_state)}`}>
          {obj.current}
        </div>
        <div className={`column ${stateToCss(obj.proposed_state)}`}>
          {obj.proposed}
        </div>
        {shouldShowImpact && (
          <div className='one wide column impact'>
            {obj.impact ? obj.impact : '0'}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className='ui fluid card'>
      <div className='content'>
        <div className='header'>{title}</div>
        <p className='meta'>{description}</p>
        <div
          className='ui divider'
          style={{ margin: 0 }}
        ></div>
        <div className='ui equal width grid properties'>
          <div className='row bold'>
            <div className='column'>Current Profiles</div>
            <div className='column'>Proposed Profiles</div>
            {shouldShowImpact && <div className='one wide column'>Impact</div>}
          </div>
          {data.map((v, i) => row(v, i))}
        </div>
      </div>
    </div>
  );
}
